<template>
  <div id="app">
    <PratkowieckaLech />
  </div>
</template>

<script>
import Vue from "vue";
import PratkowieckaLech from "@/PratkowieckaLech";
import vueSmoothScroll from "vue2-smooth-scroll";

Vue.use(vueSmoothScroll);

export default {
  name: "app",
  components: {
    PratkowieckaLech,
  }
};
</script>

<style lang="scss">
@import "scss/app";
</style>
